module.exports = __webpack_public_path__ + "static/media/room-executive-3.9e6d437e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/room-executive-3.jpg
// module id = 678
// module chunks = 6